<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <logout-card header-color="green">
        <h4 slot="title" class="title">
          BuurtBusBeheer.nl&nbsp;DEV - Uitloggen
        </h4>
        <div slot="description" class="card-description">
          U wordt nu uitgelogd. Één moment A.U.B.
        </div>
      </logout-card>
    </div>
  </div>
</template>
<script>
import { LogoutCard } from "@/components";

export default {
  components: {
    LogoutCard
  },
  data() {
    return {
      email: null,
      password: null,
      loginErrors: {},
      requesting: false,
      loggedIn: false
    };
  },
  mounted() {
    this.$http.post(this.$apiBaseUrl + "logout", { emulateJSON: true }).then(
      response => {
        this.logout();
        this.redirect();
      },
      response => {
        if (response.status === 401) {
          this.logout();
          this.redirect();
        }

        return [];
      }
    );
  },
  methods: {
    logout() {
      var keys = Object.keys(localStorage);

      for (var i in keys) {
        localStorage.removeItem(keys[i]);
      }
    },
    redirect() {
      this.$router.push("/login");
    }
  }
};
</script>

<style></style>
